import { render } from "./PcUploadArea.vue?vue&type=template&id=61d02e3b&scoped=true&ts=true"
import script from "./PcUploadArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./PcUploadArea.vue?vue&type=script&setup=true&lang=ts"

import "./PcUploadArea.vue?vue&type=style&index=0&id=61d02e3b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d02e3b"],['__file',"src/components/scan/pc/PcUploadArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61d02e3b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61d02e3b', __exports__)) {
    console.log('reload')
    api.reload('61d02e3b', __exports__)
  }
  
  module.hot.accept("./PcUploadArea.vue?vue&type=template&id=61d02e3b&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('61d02e3b', render)
  })

}


export default __exports__